module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_dokfeltoltes2.6b3b4623.jpg";